import { Pipe, PipeTransform } from '@angular/core';

import { PaginatedComponentModel } from '@blaze-shared/elements-domain';
import { isGroupByRow } from '@blaze-shared/schema-domain';

@Pipe({
  name: 'isAllSelected',
})
export class IsAllSelectedPipe implements PipeTransform {
  transform(
    data: any[],
    paginationProps: PaginatedComponentModel,
    selectionCount: number,
  ): boolean {
    return isAllSelected(data, paginationProps, selectionCount);
  }
}

export function isAllSelected(
  data: any[],
  paginationProps: PaginatedComponentModel,
  selectionCount: number,
): boolean {
  let numRows = 0;
  if (paginationProps.isServerSide || !paginationProps.enabled) {
    numRows = data.filter((data) => !isGroupByRow(data)).length;
  } else {
    const startIdx = paginationProps.pageIndex * paginationProps.pageSize;
    const endIdx = startIdx + paginationProps.pageSize;
    numRows = data.slice(startIdx, endIdx).filter((data) => !isGroupByRow(data)).length;
  }
  return selectionCount === numRows;
}
